enum Analysis {
  home= '/analysis',
}

export default Analysis;
